

















































































































import CancelButton from '@/components/buttons/CancelButton.vue'
import CaptchaSubmitButton from '@/components/buttons/CaptchaSubmitButton.vue'
import DownloadButton from '@/components/buttons/DownloadButton.vue'
import { ingoingDirection } from '@/constants/capacityDirections'
import { ProcurementStatus } from '@/services/myTender/types'
import TenderService from '@/services/tender'
import { TenderDTO, TenderOfferDTO } from '@/services/tender/types'
import { errorMessages, sortLots } from '@/utils/helpers'
import CommissionerSection from '@/views/Tender/components/CommissionerSection.vue'
import TenderBid from '@/views/Tender/components/TenderBid.vue'
import TenderHeader from '@/views/Tender/components/TenderHeader.vue'
import Vue from 'vue'

export default Vue.extend({
  name: 'TenderDetails',
  components: { DownloadButton, CancelButton, TenderHeader, TenderBid, CommissionerSection, CaptchaSubmitButton },
  props: { type: { type: String, default: '' } },
  data: function (): {
    id: string
    ingoingDirection: string[]
    selected: number
    procurement: Omit<TenderDTO, 'hasOwnBids'>
    data: TenderOfferDTO
    status: string
    redirectedFrom: string
    ProcurementStatus: typeof ProcurementStatus
    showTenderWinners: boolean
    bidsToggleIndex: number
    loading: boolean
    TenderService: typeof TenderService
  } {
    const id = 'id' in this.$route.params && this.$route.params.id
    const status = 'status' in this.$route.query && this.$route.query.status
    const redirectedFrom = 'redirectedFrom' in this.$route.query && this.$route.query.redirectedFrom
    if (!id) {
      throw new Error('EvaluateSellingTender is missing required route param id')
    }
    return {
      ProcurementStatus,
      id,
      ingoingDirection,
      selected: 0,
      status: status ? (status as string) : '',
      redirectedFrom: redirectedFrom ? (redirectedFrom as string) : '',
      procurement: {
        id: 0,
        name: '',
        type: '',
        status: '',
        timeRemaining: 0,
        description: '',
        publishDate: '',
        endDate: '',
        publishTime: '',
        endTime: '',
        lots: [],
        offersReceived: undefined,
        creator: undefined,
        isLimited: false,
      },
      data: {
        procurementId: Number(id),
        offeredCbc: null,
        cbcDirection: null,
        lotBids: [],
      },
      showTenderWinners: false,
      bidsToggleIndex: 0,
      loading: true,
      TenderService,
    }
  },
  computed: {
    selectedLot(): number {
      return this.selected ? this.selected : 0
    },
    downloadableLotBids(): boolean {
      return [
        ProcurementStatus.EVALUATING_OFFERS,
        ProcurementStatus.EVALUATING_EXPIRED,
        ProcurementStatus.CLOSED,
      ].includes(this.procurement.status as ProcurementStatus)
    },
  },
  watch: {
    bidsToggleIndex(idx: number): void {
      const wantsWinners = idx === 1
      if (this.showTenderWinners === wantsWinners) return
      this.showTenderWinners = wantsWinners
      this.fetchItem()
    },
  },
  methods: {
    async fetchItem(): Promise<void> {
      this.loading = true
      const viewableStatuses = [ProcurementStatus.PUBLISHED, ProcurementStatus.DECRYPTING_OFFERS]
      if (viewableStatuses.includes(this.status as ProcurementStatus)) {
        const { data } = await TenderService.published(this.id)
        this.procurement = data.data
        this.data.lotBids = data.data.lots.map((lot) => ({
          startTime: '',
          endTime: '',
          ...lot,
          lotId: lot.id,
          offeredPower: 0,
          pricePerUnit: 0,
          isConditional: true,
          direction: lot.direction,
          cbcOffered: lot.cbcCoverage ? lot.crossBorderCapacity?.leftoverCapacity : null,
        }))
        sortLots(this.data.lotBids)
        this.loading = false
        return
      }

      if (this.status === ProcurementStatus.EVALUATING_EXPIRED) {
        const { data } = await TenderService.offers(this.id)
        this.procurement = data.data
        this.data.lotBids = data.data.lots.map((lot) => ({
          ...lot,
          direction: '',
          lotId: lot.id,
          offeredPower: 0,
          pricePerUnit: 0,
          startTime: lot.deliveryProfile[0].startTime,
          endTime: lot.deliveryProfile[0].endTime,
          cbcOffered: lot.cbcCoverage ? lot.crossBorderCapacity?.leftoverCapacity : null,
        }))
        sortLots(this.data.lotBids)
        this.loading = false
        return
      }

      const { data } = await TenderService.winners(this.id, this.showTenderWinners)
      this.procurement = data.data
      this.data.lotBids = data.data.lots.map((lot) => ({
        ...lot,
        lotId: lot.id,
        offeredPower: 0,
        pricePerUnit: 0,
        isConditional: true,
        direction: lot.direction,
        cbcOffered: lot.cbcCoverage ? lot.crossBorderCapacity?.leftoverCapacity : null,
      }))

      sortLots(this.data.lotBids)
      this.loading = false
    },

    async submit(): Promise<void> {
      const loader = this.$loading.show()
      try {
        const response = await TenderService.confirmEvaluation(this.id, { comments: this.procurement.comments || '' })
        if (response) {
          this.$toast.success(response.data.message)
        }
        await this.redirectBack()
      } catch (err) {
        if (err.response.data) {
          this.$toast.error(errorMessages(err.response.data.message))
          return
        }
        this.$toast.error(this.$t('somethingWentWrong') as string)
      } finally {
        loader.hide()
      }
    },
    async redirectBack(): Promise<void> {
      await this.$router.push({
        name: this.type === 'buy' ? 'BuyingTenders' : this.type === 'sell' ? 'SellingTenders' : '',
      })
    },
  },
  mounted() {
    this.fetchItem()
  },
})
